import { gql } from '@apollo/client';

export const CREATE_LEAD = gql`
  mutation CreateLead(
    $email: String!
    $name: String!
    $phone: String!
    $courseSlug: String!
    $courseTitle: String!
    $newsletter: Boolean!
    $status: String!
  ) {
    attachCourseToEmail(
      email: $email
      name: $name
      phone: $phone
      courseSlug: $courseSlug
      courseTitle: $courseTitle
      newsletter: $newsletter
      status: $status
    ) {
      course {
        documentId
      }
      lead {
        documentId
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateCurrentSubscription(
    $leadDocumentId: String!
    $courseDocumentId: String!
    $status: String!
  ) {
    updateCurrentSubscription(
      leadDocumentId: $leadDocumentId
      courseDocumentId: $courseDocumentId
      status: $status
    ) {
      subscriptionStatus
    }
  }
`;
